import "./ContactUkraine.scss";
import { useState } from "react";
import { LinWithIconComponent_Plain } from "../../../types/components/shared/LinWithIconComponent.ts";
import { getStrapiMedia } from "../../../utils/utils.tsx";
import { NewsUkraine_Plain } from "../../../types/api/news-ukraine.ts";

const ContactUkraine = ({ data }: { data: NewsUkraine_Plain }) => {
  const [isHovered, setIsHovered] = useState(false);
  const socialItems = data.data.socials.map(
    (item: LinWithIconComponent_Plain, i: number) => (
      <li key={i}>
        <a href={item.link} target={item.target}>
          {item.icon ? (
            <img
              src={getStrapiMedia(item.icon.url)}
              width="50"
              alt={item.title}
            />
          ) : (
            ""
          )}
        </a>
      </li>
    ),
  );

  return (
    <section
      className={`news-contact news-contact-ukraine ${isHovered ? "news-contact_hover" : ""}`}
    >
      <div className="news-contact__bg">
        <img src={"/img/bg-contact.jpg"} width="1440" />
      </div>
      <div className="wrapper">
        <h2>
          <span>{data.data.contactTitle1}</span> {data.data.contactTitle2}
        </h2>
        <div
          className="news-contact__cart"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <div className="news-contact__cart-cont">
            <div className="news-contact__card-top">
              {/*<img src={"/img/img-contact.jpg"} width="157" />*/}
              <div className="news-contact__position">
                {data.data.contactDepartment}
              </div>
            </div>
            <div className="news-contact__symbol"></div>
            <div className="news-contact__card-bottom">
              <div className="news-contact__card-bottom-left">
                {data.data.contactEmailText}
              </div>
              <div className="news-contact__card-bottom-right">
                <div className="news-contact__email">
                  <a href={"mailto:" + data.data.contactEmail}>
                    {data.data.contactEmail}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="news-contact__bottom">
          <div className="contact-text">{data.data.contactSocials}</div>
          <div className="social-list">
            <ul>{socialItems}</ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUkraine;
